import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { DISTRESS, AVAILABLE } from 'app/constants/statusColors'

const Box = (props) => {
  const { type = AVAILABLE, children, className, ...rest } = props
  const [style, setStyle] = useState({
    box: '',
  })

  const handleColor = (type) => {
    switch (type) {
      case AVAILABLE:
        setStyle({
          box: 'text-primary-300 bg-sky-50',
        })
        break
      case DISTRESS:
        setStyle({
          box: 'text-orange-600 bg-orange-50',
        })
        break
      default:
        setStyle({ box: '', icon: '' })
    }
  }

  useEffect(() => {
    handleColor(type)
  }, [type])

  return (
    <div
      {...rest}
      className={clsx('rounded-8 py-5 px-10', className, style.box)}
    >
      {children}
    </div>
  )
}

Box.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
}

export default Box
